import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { YAMap, MapSimpleBaloon } from 'bricks/YAMap';
import { getPointsUrlsBySlug } from 'store/widgets/OfficesMap/constants';

import { TextInput, Preloader, Heading } from '..';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

export default class OfficesMapLayout extends Component {
  componentDidMount() {
    const { getPoints, pageSlug } = this.props;
    const getPointsUrl = getPointsUrlsBySlug[pageSlug];
    getPoints(pageSlug, getPointsUrl);
  }

  render() {
    const {
      isMobile,
      points,
      isPointsFetched,
      heading,
      headlineTagName,
      searchQuery,
      onSearchQueryChange,
    } = this.props;
    return (
      <div className={cx('component', isMobile ? 'mobile' : '')}>
        {heading ?
          <Heading tagName={headlineTagName} level={3} className={cx('heading')}>
            {heading}
          </Heading>
        : null}
        <div className={cx('search')}>
          <TextInput
            type="search"
            placeholder="Поиск"
            value={searchQuery}
            onChange={onSearchQueryChange}
            onClear={() => onSearchQueryChange('')}
          />
        </div>
        <div className={cx('map')}>
          {isPointsFetched ?
            <YAMap
              points={points.filter((point) => point.latitude && point.longitude)}
              isMobile={isMobile}
              mapId="officesMap"
              hasClusters
              customMapOptions={{
                balloonMinHeight: 200,
              }}
              mobileOptions={{
                balloonMinHeight: 150,
              }}
            >
              {(props) => <MapSimpleBaloon {...props} />}
            </YAMap>
          : <Preloader />}
        </div>
      </div>
    );
  }
}

OfficesMapLayout.propTypes = {
  getPoints: PropTypes.func,
  pageSlug: PropTypes.string,
  isMobile: PropTypes.bool,
  points: PropTypes.array,
  isPointsFetched: PropTypes.bool,
  heading: PropTypes.string,
  headlineTagName: PropTypes.string,
  searchQuery: PropTypes.string,
  onSearchQueryChange: PropTypes.func,
  // onSearchQueryBlur: PropTypes.func,
};
